<template>
  <scoped>
    <VerticalNavigator
      :links="[{
        title: 'Create',
        routeName: 'create_supplier'
      }]"
    >
      <Breadcrumb
        :links="[{
          title: 'RutSolve',
          routeName: 'index'
        }]"
        title="Suppliers"
      />
      <h1>
        Suppliers
      </h1>
      <div class="grid">
        <div class="list">
          <SupplierSelector v-model:value="selectedSupplier" />
        </div>
        <div
          v-if="selectedSupplier"
          class="summary"
        >
          <SupplierSummary
            :key="selectedSupplier.id"
            :supplierID="selectedSupplier.id"
          />
          <Button
            title="Edit"
            :image="require('@/images/edit_icon.png')"
            @click="supplierRedirect()"
          />
        </div>
      </div>
    </VerticalNavigator>
  </scoped>
</template>

<script setup lang="ts">
  import SupplierSelector from "@/components/selectors/supplier.vue"
  import Breadcrumb from "@/components/breadcrumb.vue"
  import VerticalNavigator from "@/layouts/vertical_navigator.vue"
  import {ref} from "vue"
  import Button from "@/components/button.vue"
  import SupplierSummary from "@/components/summaries/supplier.vue"
  import router from "@/router"
  import {Supplier} from "@/endpoints/rutsolve/gql/generated/graphql"

  const selectedSupplier = ref<Supplier>(null)

  function supplierRedirect() {
    router.push({
      name: "edit_supplier",
      params: {
        supplierID: selectedSupplier.value.id
      }
    })
  }
</script>

<style scoped>
  .grid {
    display: grid;
    grid-template-areas: "list summary";
    grid-template-columns: auto 1fr;

    .list {
      grid-area: list;
      margin: 0 1em 1em 0;
    }

    .summary {
      grid-area: summary;
    }
  }
</style>
